import { endOfDay as endOfDayDateFns, subHours } from 'date-fns';

export const endOfDay = (date?: Date) =>
  subHours(endOfDayDateFns(date || new Date()), 10);

export const startOfDay = (date?: Date) =>
  subHours(endOfDayDateFns(date || new Date()), 12);
